module.exports = __webpack_public_path__ + "static/img/gfbk2.eb07c224.png";